import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectDropDownListViewModelType from '@/ViewModels/Controls/MultiSelectDropDownListViewModel';
import KendoDropDownHelper from '@/Utility/KendoDropDownHelper';
import ResourceManager from '@/Management/ResourceManager';

export default class MultiSelectDropDownList extends Control {

    private jQueryControl: JQuery;
    private isOpen: boolean;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.MultiSelectDropDownList>;

    public constructor(private viewModel: MultiSelectDropDownListViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><select></div>');

        this.applyBindings(this.jQueryControl.find('select'), {
            kendoMultiSelectDropDownList: {
                animation: this.viewModel.animation,

                data: this.viewModel.data,

                values: this.viewModel.values,

                change: this.viewModel.onChange.bind(this.viewModel),

                open: this.onOpen.bind(this),

                close: this.viewModel.onClose.bind(this.viewModel),

                dataTextField: this.viewModel.dataTextField,

                enabled: this.viewModel.isEnabled,

                dataValueField: this.viewModel.dataValueField,

                template: this.viewModel.template,

                valueTemplate: this.viewModel.valueTemplate,

                noDataTemplate: ResourceManager.getInstance().get('NO_DATA'),

                widget: this.widget
            },

            focus: this.viewModel.isFocusable
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.MultiSelectDropDownList): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'multiselectdropdownlist',

            loader: this.viewModel.isBusy,

            interact: this.viewModel.isEnabled,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            invalid: this.viewModel.invalidationText,

            styles: this.definePureComputed({
                read: () => {
                    var styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    var states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(widget.ul.closest('.k-list-container'), {
            controlName: 'multiselectdropdownlist-container',

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(widget.wrapper, {
            autoLocator: this.viewModel.locator
        });

        KendoDropDownHelper.bindWidgetLocators(widget, this.viewModel.locator);
        KendoDropDownHelper.bindWidgetIsBusy(widget, this.viewModel.isBusy);

        this.defineSubscription(this.viewModel.data, this.resetDropDownPopupPosition.bind(this));
        widget.bind('dataBound', () => {
            this.resetDropDownPopupPosition();
        });
    }

    private onOpen() {
        this.evaluate(this.viewModel.onOpen()).then(() => {
            this.resetDropDownPopupPosition();
        });
    }

    private resetDropDownPopupPosition() {
        // Da eine Checkbox vor den Label ist, muss hierfür Platz reserviert werden
        const placeForCheckBox = '#####';
        const labels = this.viewModel.data().map((value: string) => {
            return placeForCheckBox + value[this.viewModel.dataTextField];
        });
        KendoDropDownHelper.resetDropDownPopupPosition(labels, this.jQueryControl, this.widget());
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-select';
        this.getControl().find('select').attr('id', id);
        label.attr('for', id);
        return label;
    }
}

ComponentManager.setControl('MultiSelectDropDownList', MultiSelectDropDownList, 'RADPresentation.HTMLClient.DefaultViewExtensions');